<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div id="compos">
    <div
      v-if="currentView === 'register'"
      id="name_page"
      class="container"
      :class="languageAbbrSelected"
    >
      <div class="box dialog">
        <center style="position: relative;">
          <h2 id="name_page_title">
            {{ $t("index.intro1") }}<span class="highlight_span">
              {{ $t("index.intro2") }}
            </span>{{ $t("index.intro3") }}<span class="bold_span">
              {{ $t("index.intro4") }}<span>?</span>
            </span>
          </h2>
        </center>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 13.41 20.91"
        >
          <title>dialog_fin</title><path
            d="M13.41,16.86S4.83,22.08,0,20.67C5.58,16.33,4.67,0,4.67,0h0"
            style="fill:#ddd"
          />
        </svg>
      </div>

      <!-- <div id="ad_home_1"></div> -->

      <div class="box welcome">
        <center class="welcome_titles">
          <h2>{{ $t("index.instru1") }}<span>{{ $t("index.instru2") }}</span></h2>
          <h3>{{ $t("index.instru3") }}<span>{{ $t("index.instru4") }}</span></h3>
        </center>
        <ul class="instructions">
          <li>
            <span class="v-left step-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 82.03 121.23"
              >
                <title>instructions_1</title><path
                  d="M49.31,20.93h2a10.5,10.5,0,0,1,0,21h-2a10.5,10.5,0,0,1,0-21Z"
                  style="fill:#49b66d;fill-rule:evenodd"
                /><path
                  d="M43.31,0a5.5,5.5,0,1,1-5.5,5.5A5.5,5.5,0,0,1,43.31,0Z"
                  style="fill:#2e9d58;fill-rule:evenodd"
                /><path
                  d="M48.2,119.83Q8.28,128.08,1.1,88T33.83,39.57q39.93-8.24,47.11,31.88T48.2,119.83Z"
                  style="fill:#65ff98"
                /><path d="M39.6,94a1,1,0,0,1-.31-.73V73.64L33.66,78a1.18,1.18,0,0,1-.63.21,1.09,1.09,0,0,1-.88-.51l-2.61-3.36a1.23,1.23,0,0,1-.16-.63,1.06,1.06,0,0,1,.46-.92l9.74-7.52a1.68,1.68,0,0,1,1-.29h5.54a1.12,1.12,0,0,1,.78.29,1,1,0,0,1,.32.76V93.3a1,1,0,0,1-.32.75,1.09,1.09,0,0,1-.78.3H40.34A1,1,0,0,1,39.6,94Z" />
              </svg>
            </span>
            <span
              id="instructions_step_1"
              class="v-right"
            >
              <h3>{{ $t("index.step1title") }}</h3>
              {{ $t("index.step1") }}
            </span>
          </li>

          <li>
            <span class="v-left step-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 85 143.88"
              >
                <title>instructions_2</title><path
                  d="M47.21,39.48h2.95a15.5,15.5,0,0,1,0,31H47.21a15.5,15.5,0,0,1,0-31Z"
                  style="fill:#58c0c1;fill-rule:evenodd"
                /><path
                  d="M31.13,18.73h2a10.5,10.5,0,0,1,0,21h-2a10.5,10.5,0,0,1,0-21Z"
                  style="fill:#49b5b6;fill-rule:evenodd"
                /><path
                  d="M46,0a5.5,5.5,0,1,1-5.5,5.5A5.5,5.5,0,0,1,46,0Z"
                  style="fill:#2e8f9d;fill-rule:evenodd"
                /><path
                  d="M60,137.74Q23.17,156.26,5.65,118.93T25,63.08Q61.83,44.57,79.35,81.9T60,137.74Z"
                  style="fill:#65ffdd"
                /><path d="M31.56,113.17a1,1,0,0,1-.32-.74v-3.15a2.59,2.59,0,0,1,1.05-2.1l3.91-3.82c2.66-2,4.67-3.58,6-4.7a20.55,20.55,0,0,0,3.11-3A4.23,4.23,0,0,0,46.4,93q0-3.11-3.1-3.11a3.18,3.18,0,0,0-2.52,1,5,5,0,0,0-1.18,2.45,1.29,1.29,0,0,1-1.43,1H32.63a.89.89,0,0,1-.65-.27.83.83,0,0,1-.28-.61,9.63,9.63,0,0,1,1.54-5,10.08,10.08,0,0,1,4-3.57,13.13,13.13,0,0,1,6-1.32,14.91,14.91,0,0,1,6.09,1.13,8.79,8.79,0,0,1,3.33,13.44A29.06,29.06,0,0,1,47,103.4l-3.48,3.49H54.17a1,1,0,0,1,1,1v4.49a1.08,1.08,0,0,1-.29.74,1,1,0,0,1-.76.31H32.29A1,1,0,0,1,31.56,113.17Z" />
              </svg>
            </span>
            <span
              id="instructions_step_2"
              class="v-right"
            >
              <h3>{{ $t("index.step2title") }}</h3>
              {{ $t("index.step2") }}
            </span>
          </li>
          <li>
            <span class="v-left step-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 84.96 173.94"
              >
                <title>instructions_3</title><path
                  d="M45,0a4.5,4.5,0,1,1-4.5,4.5A4.49,4.49,0,0,1,45,0Z"
                  style="fill:#45607e;fill-rule:evenodd"
                /><path
                  d="M37.09,19a8.91,8.91,0,0,1,8.9,8.9v1.2a8.9,8.9,0,1,1-17.8,0v-1.2A8.9,8.9,0,0,1,37.09,19Z"
                  style="fill:#446391;fill-rule:evenodd"
                /><path
                  d="M56.57,41a13.5,13.5,0,1,1-13.5,13.5A13.5,13.5,0,0,1,56.57,41Z"
                  style="fill:#4d72a3;fill-rule:evenodd"
                /><path
                  d="M33.86,65.45h2A19.5,19.5,0,0,1,55.36,85v2a19.5,19.5,0,0,1-19.5,19.5h-2A19.5,19.5,0,0,1,14.36,87V85A19.5,19.5,0,0,1,33.86,65.45Z"
                  style="fill:#5889c1;fill-rule:evenodd"
                /><path
                  d="M81.68,144.8q-13.11,39.57-52.3,25.41T3.28,116.5q13.11-39.56,52.3-25.4T81.68,144.8Z"
                  style="fill:#84bbff"
                /><path d="M36.3,146.17A9.85,9.85,0,0,1,32.19,143a7,7,0,0,1-1.41-3.78.83.83,0,0,1,.27-.63.91.91,0,0,1,.65-.25h5.8a1.44,1.44,0,0,1,.8.19,1.73,1.73,0,0,1,.54.61q.79,2.06,4.41,2.06a4.79,4.79,0,0,0,3.19-1,3.23,3.23,0,0,0,1.14-2.61q0-3.13-4.2-3.14h-4.7a1.09,1.09,0,0,1-1.1-1.1v-2.47a1.58,1.58,0,0,1,.72-1.43l6.76-5.55H33.47a1.06,1.06,0,0,1-1-1.05v-4.15a1.12,1.12,0,0,1,.29-.78,1,1,0,0,1,.76-.32H53a1,1,0,0,1,.76.32,1.12,1.12,0,0,1,.29.78v3.73a1.67,1.67,0,0,1-.67,1.39l-6.22,5.67.29.08a10.92,10.92,0,0,1,6,2.61,7.63,7.63,0,0,1,2.23,5.92,7.87,7.87,0,0,1-1.62,4.93,10.21,10.21,0,0,1-4.45,3.26,17.17,17.17,0,0,1-6.45,1.13A16.46,16.46,0,0,1,36.3,146.17Z" />
              </svg>
            </span>
            <span
              id="instructions_step_3"
              class="v-right"
            >
              <h3>{{ $t("index.step3title") }}</h3>
              {{ $t("index.step3") }}
            </span>
          </li>
        </ul>
      </div>

      <!-- <div id="ad_home_2"></div> -->

      <div class="box location">
        <center class="location_titles">
          <h2>{{ $t("index.registerintro") }}</h2>
          <h3>{{ $t("index.registersub1") }}<span>{{ $t("index.registersub2") }}</span></h3>
        </center>
        <div
          id="drop_country"
        >
          <h4
            id="select_region_title"
            class=""
          >
            {{ $t("index.region") }}
          </h4>
          <b-dropdown aria-role="list">
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ countrySelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(country, index) in countries"
              :key="country.id"
              aria-role="listitem"
              @click="country_selected(index)"
            >
              {{ country }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div
          v-if="countryAbbrSelected !== ''"
          id="drop_language"
        >
          <h4
            id="select_language_title"
            class=""
          >
            {{ $t("index.language") }}
          </h4>
          <b-dropdown
            v-if="countryAbbrSelected === 'NA'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(naLanguage, index) in naLanguages"
              :key="naLanguage.id"
              aria-role="listitem"
              @click="naLanguage_selected(index)"
            >
              {{ naLanguage }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            v-else-if="countryAbbrSelected === 'LA'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(laLanguage, index) in laLanguages"
              :key="laLanguage.id"
              aria-role="listitem"
              @click="laLanguage_selected(index)"
            >
              {{ laLanguage }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            v-else-if="countryAbbrSelected === 'EU'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(euLanguage, index) in euLanguages"
              :key="euLanguage.id"
              aria-role="listitem"
              @click="euLanguage_selected(index)"
            >
              {{ euLanguage }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            v-else-if="countryAbbrSelected === 'AS'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(asLanguage, index) in asLanguages"
              :key="asLanguage.id"
              aria-role="listitem"
              @click="asLanguage_selected(index)"
            >
              {{ asLanguage }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            v-else-if="countryAbbrSelected === 'AF'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(afLanguage, index) in afLanguages"
              :key="afLanguage.id"
              aria-role="listitem"
              @click="afLanguage_selected(index)"
            >
              {{ afLanguage }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            v-else-if="countryAbbrSelected === 'AU'"
            aria-role="list"
          >
            <button
              slot="trigger"
              class="button dropdown-arrow fullWidthButton"
            >
              <span>{{ languageSelected }}</span>
            </button>
            <b-dropdown-item
              v-for="(auLanguage, index) in auLanguages"
              :key="auLanguage.id"
              aria-role="listitem"
              @click="auLanguage_selected(index)"
            >
              {{ auLanguage }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div
          id="input_name"
        >
          <h4 id="enter_your_name_title">
            {{ $t("index.name") }}
          </h4>
          <b-input
            v-model="theName"
            maxlength="15"
            placeholder="Alex..."
            required
            @keyup.enter.native="save_name"
          />
        </div>

        <button
          id="name_button"
          class="fullWidthButton pushdown"
          type="button"
          @click="save_name()"
        >
          {{ $t("index.started") }}
        </button>

        <div
          id="info_namepage"
          class="infobox"
        >
          <i class="fas fa-ellipsis-h" />
          <span id="note_on_name_page">
            Note:
          </span>
        </div>
      </div>
      <!-- <div id="ad_home_3"></div> -->
      <!-- 300x250 waldo-tag-15192 -->
      <div id="ad-bottom-register" style="text-align: center;"/>
    </div>

    <!-- 728x90 sticky footer Desktop Only
    <div id="waldo-tag-15164" /> -->

    <div v-if="$isMobile()" />
    <div v-else>
      <!-- 300x600/160x600 sticky sidebar - Desktop Only-->
      <div class="sidebar-wrapper-left">
      </div>

      <!-- 300x600/160x600 Desktop Only -->
      <div class="sidebar-wrapper-right">
      </div>
    </div>

    <!-- <Ad6Compo
      v-if="currentView === 'register'"
    /> -->

    <CreationCompo
      :current-view="currentView"
      :the-name="theName"
      :lang-location="langLocation"
      :questions-array="questionsArray"
      :user-id="userId"
      :has-user="hasUser"
      :language-abbr-selected="languageAbbrSelected"
    />
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import CreationCompo from '@/components/CreationCompo.vue'
import { countries, countriesAbbr,
  naLanguages, naLanguagesAbbr, laLanguages, laLanguagesAbbr, euLanguages, euLanguagesAbbr, asLanguages, asLanguagesAbbr, afLanguages, afLanguagesAbbr, auLanguages, auLanguagesAbbr,
  naQuestionsEnglish, naQuestionsSpanish, naQuestionsFrench, laQuestionsSpanish, laQuestionsPortuguese, laQuestionsEnglish, euQuestionsEnglish, euQuestionsSpanish, euQuestionsNorwegian, euQuestionsFrench, euQuestionsPortuguese, euQuestionsItaliano, asQuestionsEnglish, afQuestionsEnglish, auQuestionsEnglish
} from '@/consts'
// import Ad6Compo from '@/components/Ad6Compo.vue'
import Vue from 'vue'
import RaptiveAds from '@/plugins/raptive.js';

export default {
  name: 'RegisterCompo',
  components: {
    CreationCompo
    // Ad6Compo
  },
  // eslint-disable-next-line
  props: [ 'userId', 'hasUser' ],
  data () {
    return {
      currentView: 'register',
      countries: countries,
      naLanguages: naLanguages,
      laLanguages: laLanguages,
      euLanguages: euLanguages,
      asLanguages: asLanguages,
      afLanguages: afLanguages,
      auLanguages: auLanguages,
      countryAbbrSelected: '',
      countrySelected: 'Select your region',
      languageAbbrSelected: '',
      languageSelected: 'Select your language',
      theName: '',
      naQuestionsEnglish: naQuestionsEnglish,
      naQuestionsSpanish: naQuestionsSpanish,
      naQuestionsFrench: naQuestionsFrench,
      laQuestionsSpanish: laQuestionsSpanish,
      laQuestionsPortuguese: laQuestionsPortuguese,
      laQuestionsEnglish: laQuestionsEnglish,
      euQuestionsEnglish: euQuestionsEnglish,
      euQuestionsSpanish: euQuestionsSpanish,
      euQuestionsNorwegian: euQuestionsNorwegian,
      euQuestionsFrench: euQuestionsFrench,
      euQuestionsPortuguese: euQuestionsPortuguese,
      euQuestionsItaliano: euQuestionsItaliano,
      asQuestionsEnglish: asQuestionsEnglish,
      afQuestionsEnglish: afQuestionsEnglish,
      auQuestionsEnglish: auQuestionsEnglish,
      questionsArray: [],
      canRegister: false
      // playwireUnits: [
      //   // {
      //   //   selectorId: 'ad_home_1',
      //   //   type: 'leaderboard_atf'
      //   // },
      //   // {
      //   //   selectorId: 'ad_home_2',
      //   //   type: 'leaderboard_atf'
      //   // },
      //   {
      //     selectorId: 'ad_home_3',
      //     type: 'med_rect_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ]
    }
  },
  computed: {
    langLocation: function () {
      if (this.countryAbbrSelected !== '' && this.languageAbbrSelected !== '') {
        return this.countryAbbrSelected + '-' + this.languageAbbrSelected
      } else {
        return false
      }
    }
  },
  mounted () {
    Vue.use(RaptiveAds)
    // waldo.refreshTag('waldo-tag-15164')
    // waldo.refreshTag('waldo-tag-15192')
    // if (!this.$isMobile()) {
    //   waldo.refreshTag('waldo-tag-15166')
    //   waldo.refreshTag('waldo-tag-15167')
    // }
  // // As an instance method inside a component
  //   this.$loadScript('//cdn.thisiswaldo.com/static/js/15148.js')
  //     .then(() => {
  //       // Script is loaded, do something
  //     })
  //     .catch(() => {
  //       // Failed to fetch script
  //     })
    // ramp.onReady = this.initTyche()
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API is initialized')
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    country_selected (index) {
      let countryAbbr
      let country
      countryAbbr = countriesAbbr[index]
      country = countries[index]
      this.countryAbbrSelected = countryAbbr
      this.countrySelected = country
    },
    naLanguage_selected (index) {
      this.languageAbbrSelected = naLanguagesAbbr[index]
      this.languageSelected = naLanguages[index]
      this.$i18n.locale = naLanguagesAbbr[index]
    },
    laLanguage_selected (index) {
      this.languageAbbrSelected = laLanguagesAbbr[index]
      this.languageSelected = laLanguages[index]
      this.$i18n.locale = laLanguagesAbbr[index]
    },
    euLanguage_selected (index) {
      this.languageAbbrSelected = euLanguagesAbbr[index]
      this.languageSelected = euLanguages[index]
      this.$i18n.locale = euLanguagesAbbr[index]
    },
    asLanguage_selected (index) {
      this.languageAbbrSelected = asLanguagesAbbr[index]
      this.languageSelected = asLanguages[index]
      this.$i18n.locale = asLanguagesAbbr[index]
    },
    afLanguage_selected (index) {
      this.languageAbbrSelected = afLanguagesAbbr[index]
      this.languageSelected = afLanguages[index]
      this.$i18n.locale = afLanguagesAbbr[index]
    },
    auLanguage_selected (index) {
      this.languageAbbrSelected = auLanguagesAbbr[index]
      this.languageSelected = auLanguages[index]
      this.$i18n.locale = auLanguagesAbbr[index]
    },
    save_name () {
      if (this.theName === '') {
        this.danger(this.$t('index.lackname'))
      } else if (this.theName.length <= 2) {
        this.danger(this.$t('index.tooshort'))
      } else if (!this.theName.length) {
        this.danger(this.$t('index.lackname2'))
      } else if (this.countryAbbrSelected === '') {
        this.danger(this.$t('index.lackregion'))
      } else if (this.languageAbbrSelected === '') {
        this.danger(this.$t('index.lacklanguage'))
      } else {
        this.canRegister = true
      }
      // if (this.theName !== '' && this.countryAbbrSelected !== '' && this.languageAbbrSelected !== '') {
      if (this.canRegister) {
        // eslint-disable-next-line
        this.theName = this.theName.replace(/[&\\\#,+$~%.:;*<>{}|]/g, '')
        this.currentView = 'creation'
        this.$emit('headerEvent', false)
        window.scrollTo(0, 0)

        if (this.langLocation === 'NA-EN') {
          this.questionsArray = this.naQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'NA-ES') {
          this.questionsArray = this.naQuestionsSpanish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'NA-FR') {
          this.questionsArray = this.naQuestionsFrench
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'LA-ES') {
          this.questionsArray = this.laQuestionsSpanish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'LA-PT') {
          this.questionsArray = this.laQuestionsPortuguese
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'LA-EN') {
          this.questionsArray = this.laQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-EN') {
          this.questionsArray = this.euQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-ES') {
          this.questionsArray = this.euQuestionsSpanish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-NO') {
          this.questionsArray = this.euQuestionsNorwegian
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-FR') {
          this.questionsArray = this.euQuestionsFrench
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-PT') {
          this.questionsArray = this.euQuestionsPortuguese
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'EU-IT') {
          this.questionsArray = this.euQuestionsItaliano
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'AS-EN') {
          this.questionsArray = this.asQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'AF-EN') {
          this.questionsArray = this.afQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        } else if (this.langLocation === 'AU-EN') {
          this.questionsArray = this.auQuestionsEnglish
          for (let i = 0; i < this.questionsArray.length; i++) {
            this.questionsArray[i].question = this.questionsArray[i].question.replace('^name^', this.theName)
          }
        }
      }
    },
    danger (message) {
      this.$buefy.notification.open({
        closable: true,
        duration: 2000,
        message: message,
        position: 'is-top',
        type: 'is-danger',
        hasIcon: false
      })
    }
  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.sidebar-wrapper-right, .sidebar-wrapper-left {
  position: fixed;
  text-align: center;
  z-index: 9999;
  margin-bottom: 0 !important;
  top: 50%;
  transform: translate(0, -50%);
}
.sidebar-wrapper-left {
  left: 0;
}
.sidebar-wrapper-right {
  right: 0;
}

</style>
